<template>
  <div class="content">
    <div class="pages" v-if="this.total">
      <span style="color: #000"
        >{{
          this.pageNumber > 1
            ? (this.pageNumber - 1) * this.onPage + 1 + " -"
            : ""
        }}
        {{
          Math.round(this.total) / this.onPage > 1
            ? this.pageNumber * this.onPage
            : this.total
        }}</span
      >
      <span style="font-weight: 400"> na </span>
      <span style="color: #000">{{ this.total }}</span>
    </div>
    <div class="icons">
      <img
        src="../icons/arrowLeft.svg"
        @click="previousPage()"
        class="leftArrow"
        v-if="this.pageNumber > 1"
      />
      <img
        src="../icons/arrowLeftDisabled.svg"
        v-else
        class="disabled-icon leftArrow"
      />

      <img
        src="../icons/arrowRight.svg"
        @click="nextPage()"
        class="rightArrow"
        v-if="calcPage()"
      />
      <img
        src="../icons/arrowRightDisabled.svg"
        v-else
        class="disabled-icon rightArrow"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "pageNumber",
    "onPage",
    "total",
    "dispatchAction",
    "filterParam",
    "searchParam",
    "secondFilterParam",
    "thirdFilterParam",
    "dateFrom",
    "dateTo",
    "dateField",
    "loading",
    "emitRefresh",
    // Dodatkowe filtry listy, które nie mieszczą się w stałych slotach powyżej (raport "Obiady" ma ich
    // sześć: kategorie, podkategorie, usługi, typ, status, użytkownik). Obiekt jest dokładany do payloadu
    // każdej zmiany strony - bez niego przejście na kolejną stronę gubiłoby te filtry.
    "extraParams",
  ],

  emits: ["load"],

  model: {
    prop: "loading",
    event: "load",
  },

  watch: {
    emitRefresh() {
      this.refresh();
    },
  },
  methods: {
    // Wspólny payload dla każdej zmiany strony - musi nieść WSZYSTKIE aktywne
    // filtry (łącznie z zakresem dat), inaczej przejście na kolejną stronę
    // pobiera nieprzefiltrowaną listę.
    dispatchParams(pageNumber) {
      return {
        ...(this.extraParams || {}),
        on_page: this.onPage,
        page_number: pageNumber,
        filter_param: this.filterParam,
        second_filter_param: this.secondFilterParam,
        third_filter_param: this.thirdFilterParam,
        sort_by: this.sortingParams,
        search_param: this.searchParam,
        date_from: this.dateFrom,
        date_to: this.dateTo,
        date_field: this.dateField,
      };
    },
    refresh() {
      this.$emit("load", true);
      this.$store.dispatch(this.dispatchAction, this.dispatchParams(this.pageNumber));
      this.$emit("load", false);
    },
    calcPage() {
      const page_number = this.pageNumber;
      const total_value = this.total;
      const on_page = this.onPage;

      if (total_value / on_page > page_number) {
        return true;
      } else {
        return false;
      }
    },
    async nextPage() {
      this.$emit("load", true);
      await this.$store.dispatch(
        this.dispatchAction,
        this.dispatchParams(this.pageNumber + 1)
      );
      this.$emit("load", false);
    },

    async previousPage() {
      this.$emit("load", true);
      await this.$store.dispatch(
        this.dispatchAction,
        this.dispatchParams(this.pageNumber - 1)
      );
      this.$emit("load", false);
    },
  },

  computed: {},
};
</script>

<style scoped>
.icons img {
  height: 30px;
  cursor: pointer;
  border: 1px solid #e5e5e9;
  padding: 5px 20px 5px 20px;
}
.rightArrow {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.leftArrow {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.content {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.pages {
  font-size: 14px;
  font-weight: bold;
}
</style>
